import React, { useRef, useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { FaPhoneAlt } from 'react-icons/fa';
import { IoIosMail, IoIosPin } from 'react-icons/io';
import { Socials } from './Socials';

export const Hamburger = ({ page }) => {
	const location = useLocation();
	const hamburger = useRef(null);
	const lastScrollY = useRef(window.scrollY);
	const [overlay, setOverlay] = useState(false);
	const [isHidden, setIsHidden] = useState(false);

	const hamburgerOpen = () => {
		setOverlay(!overlay);
		!overlay ? document.body.classList.add('mobile-menu-open') : document.body.classList.remove('mobile-menu-open');
	};

	useEffect(() => {
		//remove body mobile-menu-open when switching page
		overlay ? document.body.classList.add('mobile-menu-open') : document.body.classList.remove('mobile-menu-open');
	}, [location.pathname]);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (overlay && hamburger.current && !hamburger.current.contains(event.target)) {
				setOverlay(false);
				document.body.classList.remove('mobile-menu-open');
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () => document.removeEventListener('mousedown', handleClickOutside);
	}, [overlay]);

	useEffect(() => {
		const scrollThreshold = 90; // px – tweak to taste

		const handleScroll = () => {
			if (overlay) return;

			const currentScrollY = window.scrollY;
			const isScrollingDown = currentScrollY > lastScrollY.current;
			const passedThreshold = currentScrollY > scrollThreshold;

			if (passedThreshold) {
				if (isScrollingDown) {
					setIsHidden(true); // scroll down → hide
				} else {
					setIsHidden(false); // scroll up → show
				}
			} else {
				// Always show near top
				setIsHidden(false);
			}

			lastScrollY.current = currentScrollY;
		};

		window.addEventListener('scroll', handleScroll, { passive: true });
		return () => window.removeEventListener('scroll', handleScroll);
	}, []);

	return (
		<>
			<nav ref={hamburger} className={`primary-nav-container-curtain ${page === '/' ? 'light' : 'dark'}`}>
				<div className={`${overlay ? 'hamburger-icon open' : 'hamburger-icon'} ${isHidden ? 'nav-up' : 'nav-down'}`} onClick={hamburgerOpen}>
					<div className="hamburger"></div>
				</div>
				<div className={overlay ? 'overlay open' : 'overlay'}>
					<div className="overlay-content">
						<div className="link-wrapper">
							<Link className={location.pathname === '/' ? 'menu-item active' : 'menu-item'} to="/">
								Main
							</Link>
						</div>
						<div className="link-wrapper">
							<Link className={location.pathname === '/studio' ? 'menu-item active' : 'menu-item'} to="/studio">
								The Studio
							</Link>
						</div>
						<div className="link-wrapper">
							<Link className={location.pathname === '/contact' ? 'menu-item active' : 'menu-item'} to="/contact">
								Contact
							</Link>
						</div>
						<div className="nav-contacts-container">
							<div className="nav-contact">
								<a href="tel:0046707467233" target="_blank" rel="noreferrer">
									{' '}
									<FaPhoneAlt /> 0707467233
								</a>
							</div>
							<div className="nav-contact">
								<a href="mailto:janne@springstudio.se" target="_blank" rel="noreferrer">
									<IoIosMail /> janne@springstudio.se
								</a>
							</div>
							<div className="nav-address">
								<a href="https://maps.app.goo.gl/Nv89i1ivAesHQNt59" target="_blank" rel="noreferrer">
									<IoIosPin /> Instrumentvägen 29
								</a>
							</div>
						</div>
						<div className="nav-socials-container">
							<Socials />
						</div>
					</div>
				</div>
			</nav>
		</>
	);
};
